import { render } from "./PricesAccessories.vue?vue&type=template&id=783ec09c&scoped=true"
import script from "./PricesAccessories.vue?vue&type=script&lang=js"
export * from "./PricesAccessories.vue?vue&type=script&lang=js"

import "./PricesAccessories.vue?vue&type=style&index=0&id=783ec09c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783ec09c"]])

export default __exports__